export default "__VITE_ASSET__C36SdCuu__"